import React from 'react';
import CSelect from 'src/components/form/Select';
import MaterialInput from 'src/components/form/MaterialInput';
import CheckBox from 'src/components/form/CheckBox';
import { Poppins, Spacer } from 'src/common';
import { ConfigSchema } from './fieldSpec';
import { FormField } from './FormField';

type Opt = { label: string; value: string };

// Renders a settings form from a component's field-spec using the app-standard
// form controls (CSelect / MaterialInput / CheckBox / InputLabel). Controlled —
// owns no state; edits flow straight back through onChange.
export const AutoForm: React.FC<{
  schema: ConfigSchema;
  value: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
}> = ({ schema, value, onChange }) => {
  const set = (key: string, v: unknown) => onChange({ ...value, [key]: v });

  return (
    <>
      {schema.map((f) => {
        if (f.type === 'enum') {
          const opts: Opt[] = f.options.map((o) => ({ label: o.label, value: o.value }));
          const current = String(value[f.key] ?? '');
          return (
            <FormField key={f.key} label={f.label} required={f.required}>
              <CSelect
                inputId={f.key}
                name={f.key}
                options={opts}
                value={opts.find((o) => o.value === current) ?? null}
                onChange={(o: Opt) => set(f.key, o.value)}
              />
            </FormField>
          );
        }
        if (f.type === 'boolean') {
          return (
            <React.Fragment key={f.key}>
              <Spacer $px={20} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <CheckBox isChecked={Boolean(value[f.key])} onClick={(v) => set(f.key, v)} />
                <Poppins px={14}>{f.label}</Poppins>
              </div>
            </React.Fragment>
          );
        }
        return (
          <FormField key={f.key} label={f.label} required={f.required}>
            <MaterialInput
              fullWidth
              name={f.key}
              placeholder={f.placeholder}
              value={String(value[f.key] ?? '')}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => set(f.key, e.target.value)}
            />
          </FormField>
        );
      })}
    </>
  );
};
